import * as React from "react";
import AddJobFormBody from "./AddJobFormBody";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import JobForm from "./JobForm";
import User from "../../../model/user/User";
import {none, Option, option} from "ts-option";
import JobData from "../../../model/job/JobData";
import FormButtonsView from "../../ui/form/FormButtonsView";
import SiteData from "../../../model/site/SiteData";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import {BaseFormViewProps, BaseFormViewState, default as BaseFormView} from "../../ui/form/BaseFormView";

interface ComponentProps {
	/**
	 * On form submit callback.
	 * @param job
	 * @param watchers
	 * @param assignees
	 */
	onSubmit?: (job: JobData,
		siteData: Option<SiteData>,
		watchers: string[],
		agentId: Option<string>) => void;
}

interface ReduxProps {
	/**
	 * Logged in user detail
	 */
	user: User,
}


type State = BaseFormViewState<JobForm>

type Props = ReduxProps & ComponentProps & BaseFormViewProps;

class AddJobFormView extends BaseFormView<JobForm, Props, State> {

	constructor(props: Props) {
		super(props);
		const agentId = this.props.user.isAgent() ? option(this.props.user.id) : none;
		const form = JobForm.createEmpty(agentId);
		this.state = {
			form,
			shouldValidate: false,
			isFormDirty: false,
		};
		this.submitForm = this.submitForm.bind(this);
	}

	render() {
		return (
			<React.Fragment>
				<AddJobFormBody
					form={this.state.form}
					onFieldChange={this.onFieldChanged}
					onFieldCompleted={this.onFieldCompleted}
					onFocusChange={this.onFocusChange}
					onFieldsChange={this.onFieldsChanged}/>
				<FormButtonsView align={"right"}>
					<ButtonPrimary label={"Save"}
								   onClick={this.submitForm}
								   isLoading={this.props.isLoading}
								   disabled={this.props.isLoading}/>
				</FormButtonsView>
			</React.Fragment>
		)
	}

	submitForm() {
		this.setState({shouldValidate: true, form: this.state.form.validate()}, () => {
			this.state.form.onValid((jobData, siteData, watchers, agentId) => {
				this.props.onSubmit(jobData, siteData, watchers, agentId);
			})
		})
	}
}

function mapStateToProps(state: RootState) {
	return {
		user: state.user.user.get,
	}
}

export default connect(mapStateToProps)(AddJobFormView)